import { ApiClient } from 'src/api/client/ApiClient'
import { apiOps } from 'src/api/defs/apiOps'
import { LockPin } from 'src/api/defs/LockPin.type'
import { BooleanValue } from 'src/api/defs/BooleanValue.type'
import { ContractCancellationOptions } from 'src/api/defs/ContractCancellationOptions.type'
import { Day } from 'src/api/defs/Day.type'
import { RequestCancellationCmd } from 'src/api/defs/RequestCancellationCmd.type'

export class ContractApi {
    constructor(private api: ApiClient) {}

    getAccessPin = (contractId: number): Promise<string> =>
        this.api
            .do<LockPin>(apiOps.Contract.getLockAccessPin, {
                pathParams: { id: contractId }
            })
            .then(res => res.value)

    firstPossibleCancellationDate = async (
        contractId: number
    ): Promise<Day> => {
        const res = await this.api.do<ContractCancellationOptions>(
            apiOps.Contract.cancellationOptions,
            {
                pathParams: { id: contractId }
            }
        )

        return res.from
    }

    wasCancellationRequested = (contractId: number): Promise<boolean> =>
        this.api
            .do<BooleanValue>(apiOps.Contract.wasCancellationRequested, {
                pathParams: { id: contractId }
            })
            .then(res => res.value)

    requestCancellation = (
        contractId: number,
        cmd: RequestCancellationCmd
    ): Promise<any> =>
        this.api
            .do<BooleanValue>(apiOps.Contract.requestCancellation, {
                pathParams: { id: contractId },
                data: {
                    day: cmd.day,
                    note: cmd.note || null,
                    reasons: cmd.reasons
                }
            })
            .then(res => res.value)

    confirmEviction = (contractId: number): Promise<any> =>
        this.api
            .do<any>(apiOps.Contract.evict, {
                pathParams: { id: contractId }
            })
            .then(res => res.value)
}
